import { render, staticRenderFns } from "./LiveRating.vue?vue&type=template&id=1dbed912&scoped=true"
import script from "./LiveRating.vue?vue&type=script&lang=js"
export * from "./LiveRating.vue?vue&type=script&lang=js"
import style0 from "./LiveRating.vue?vue&type=style&index=0&id=1dbed912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbed912",
  null
  
)

export default component.exports